var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFiltericon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 5.83325H5",
    stroke: "#678DFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 14.1665H7.5",
    stroke: "#678DFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 14.1665L17.5 14.1665",
    stroke: "#678DFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 5.83325L17.5 5.83325",
    stroke: "#678DFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5 5.83325C5 5.05668 5 4.6684 5.12687 4.36211C5.29602 3.95373 5.62048 3.62928 6.02886 3.46012C6.33515 3.33325 6.72343 3.33325 7.5 3.33325C8.27657 3.33325 8.66485 3.33325 8.97114 3.46012C9.37952 3.62928 9.70398 3.95373 9.87313 4.36211C10 4.6684 10 5.05668 10 5.83325C10 6.60982 10 6.99811 9.87313 7.30439C9.70398 7.71277 9.37952 8.03723 8.97114 8.20638C8.66485 8.33325 8.27657 8.33325 7.5 8.33325C6.72343 8.33325 6.33515 8.33325 6.02886 8.20638C5.62048 8.03723 5.29602 7.71277 5.12687 7.30439C5 6.99811 5 6.60982 5 5.83325Z",
    stroke: "#678DFF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10 14.1665C10 13.3899 10 13.0016 10.1269 12.6954C10.296 12.287 10.6205 11.9625 11.0289 11.7934C11.3351 11.6665 11.7234 11.6665 12.5 11.6665C13.2766 11.6665 13.6649 11.6665 13.9711 11.7934C14.3795 11.9625 14.704 12.287 14.8731 12.6954C15 13.0016 15 13.3899 15 14.1665C15 14.9431 15 15.3314 14.8731 15.6376C14.704 16.046 14.3795 16.3705 13.9711 16.5396C13.6649 16.6665 13.2766 16.6665 12.5 16.6665C11.7234 16.6665 11.3351 16.6665 11.0289 16.5396C10.6205 16.3705 10.296 16.046 10.1269 15.6376C10 15.3314 10 14.9431 10 14.1665Z",
    stroke: "#678DFF"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiltericon);
export default __webpack_public_path__ + "static/media/filtericon.27f5c474a60c0b5d0a3e0790a26ae1cc.svg";
export { ForwardRef as ReactComponent };